import { Link, type LinkProps } from '@tanstack/react-router'
import { Fragment } from 'react'
import { cn } from '@/shared/lib'

// Контекст текущего экрана в топбаре: `компания / проект`. Mono, промежуточные
// сегменты кликабельны (Link), последний — текущий (без ссылки).

export interface Crumb {
  label: string
  to?: LinkProps['to']
  params?: LinkProps['params']
  search?: LinkProps['search']
}

interface BreadcrumbProps {
  items: Crumb[]
  className?: string
}

export function Breadcrumb({ items, className }: BreadcrumbProps) {
  return (
    <nav
      aria-label="Хлебные крошки"
      className={cn('flex min-w-0 items-center gap-2 font-mono text-sm', className)}
    >
      {items.map((crumb, i) => {
        const last = i === items.length - 1
        return (
          // biome-ignore lint/suspicious/noArrayIndexKey: крошки — статичный упорядоченный список; `to` не уникален (два сегмента ведут на один роут с разным search)
          <Fragment key={i}>
            {i > 0 && <span className="shrink-0 select-none text-text-tertiary">/</span>}
            {crumb.to && !last ? (
              <Link
                to={crumb.to}
                {...(crumb.params ? { params: crumb.params } : {})}
                {...(crumb.search ? { search: crumb.search } : {})}
                title={crumb.label}
                className="min-w-0 truncate text-text-secondary transition-colors hover:text-text-primary"
              >
                {crumb.label}
              </Link>
            ) : (
              <span
                title={crumb.label}
                className={cn(
                  'min-w-0 truncate',
                  last ? 'text-text-primary' : 'text-text-secondary',
                )}
                aria-current={last ? 'page' : undefined}
              >
                {crumb.label}
              </span>
            )}
          </Fragment>
        )
      })}
    </nav>
  )
}
